import { BrowserRouter, Navigate, Route, Routes, } from "react-router-dom";
import Loader from "./components/Common/Loader";
import React from "react";
import { AuthProvider } from "./hooks/useAuth";
import { ProtectedRoute } from "./components/ProtectedRoute";
import BackgroundVideo from "./components/Common/BackgroundVideo";

const LandingPage = React.lazy(() => import('./components/LandingPage/LandingPage'));
const LoginPage = React.lazy(() => import('./components/LoginPageComponents/LoginPage'));
const VotePage = React.lazy(() => import('./components/VotePage/VotePage'));

function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AuthProvider>
        <Routes>
          <Route element={<BackgroundVideo />}>
            <Route
              path="/vote"
              element={
                <React.Suspense fallback={<Loader isLoading />}>
                  <VotePage title={"Vote"} />
                </React.Suspense>
              }
            />
          </Route>
          <Route element={<BackgroundVideo />}>
            <Route
              path="/"
              element={
                <React.Suspense fallback={<Loader isLoading />}>
                  <ProtectedRoute>
                    <LandingPage title={"Votes"} />
                  </ProtectedRoute>
                </React.Suspense>
              }
            />
          </Route>
          <Route path="/login" element={
            <React.Suspense fallback={<Loader isLoading />}>
              <LoginPage title={"Login"} />
            </React.Suspense>
          }
          />
          <Route path="*" element={<Navigate to='/' replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
